import React from "react";

interface IDropdownTriangleProps {
  className?: string;
}

export const DropdownTriangle: React.FC<IDropdownTriangleProps> = ({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    width={18}
    height={9}
    viewBox="0 0 16 8"
  >
    {/* Фон треугольника цветом панели */}
    <path fill="var(--bg-header)" d="M0,8 L8,0 L16,8 Z" />
    {/* Только боковые линии, без нижней грани */}
    <path
      fill="none"
      stroke="var(--border-default)"
      strokeWidth="1"
      d="M0,8 L8,0 L16,8"
    />
  </svg>
);
